import { ArrowUpAZIcon, ListFilter } from 'lucide-react';
import React, { useEffect, useState, useMemo } from 'react';
import { checkLoginStatus, getUserData, updateUserData, logoutUser } from '../api/authService';
import { Toast, ToastContainer } from '../components/Toast';
import FilterBar from '../components/FilterBar';
import AdminPage from './admin/page';
const correctCode = 'tsoAdmin2';

const navigate = (url) => {
    window.location.href = url;
}


const Admin = () => {
    const [code, setCode] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [error, setError] = useState('');
    const [isVerifying, setIsVerifying] = useState(false);

    const [showAdmin, setShowAdmin] = useState(false);
    const [user, setUser] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchUserData();
        // fetchUserComments();
    }, []);

    const navigate = (url) => {
        window.location.href = url;
    }

    const fetchUserData = async () => {
        const loggedIn = await checkLoginStatus();
        if (!loggedIn) {
            navigate('/');
            return;
        }
        try {
            const userData = await getUserData();
            if (!userData) {
                Toast.error('Error fetching user:');
                navigate('/');
                return;
            }
            setUser(userData);
            if (userData?.roles?.includes('editor') || userData?.roles?.includes('administrator')) {
                setShowAdmin(true);
                setIsLoading(false);
            } else {
                setIsLoading(false);
                navigate('/');
            }
        } catch (error) {
            Toast.error('Error fetching user:', error);
            navigate('/');
        } finally {
            setIsLoading(false);
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        setIsVerifying(true);

        setTimeout(() => {
            if (code.trim() === correctCode) {
                setIsVerified(true);
            } else {
                setError('Incorrect code. Please try again.');
            }
            setIsVerifying(false);
        }, 1500); // Simulate network delay
    };

    if (isVerified) {
        return <RegistrantsTable />;
    }

    // return (
    //     <div className="flex flex-col items-center justify-center min-h-screen bg-gray-700 p-6">
    //         <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md">
    //             <h2 className="text-xl font-semibold text-gray-800 mb-4">
    //                 Admin Page (Under Development)
    //             </h2>
    //             <p className="text-sm text-gray-600 mb-4">
    //                 This admin interface is still under development. Enter the access code to proceed.
    //             </p>

    //             <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
    //                 <input
    //                     type="password"
    //                     placeholder="Enter admin access code"
    //                     className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-amber-500"
    //                     value={code}
    //                     onChange={(e) => {
    //                         setCode(e.target.value);
    //                         setError('');
    //                     }}
    //                     disabled={isVerifying}
    //                 />

    //                 {error && <p className="text-red-500 text-sm">{error}</p>}

    //                 <button
    //                     type="submit"
    //                     disabled={isVerifying}
    //                     className={`flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-700 text-white font-medium py-2 px-4 rounded-lg transition ${isVerifying ? 'opacity-70 cursor-not-allowed' : ''
    //                         }`}
    //                 >
    //                     {isVerifying ? (
    //                         <>
    //                             <span className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></span>
    //                             Verifying...
    //                         </>
    //                     ) : (
    //                         'Verify'
    //                     )}
    //                 </button>
    //             </form>
    //         </div>
    //     </div>
    // );

    return (
        <div className='bg-white relative'>
            {showAdmin && <AdminPage />}
        </div>
    )

};






// const oldAdmin = () => {
//     const [code, setCode] = useState('');
//     const [isVerified, setIsVerified] = useState(false);
//     const [error, setError] = useState('');
//     const [isVerifying, setIsVerifying] = useState(false);

//     const [showAdmin, setShowAdmin] = useState(false);
//     const [user, setUser] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);

//     useEffect(() => {
//         // fetchUserData();
//         // fetchUserComments();
//     }, []);

//     const navigate = (url) => {
//         window.location.href = url;
//     }

//     const fetchUserData = async () => {
//         const loggedIn = await checkLoginStatus();
//         if (!loggedIn) {
//             navigate('/');
//             return;
//         }
//         try {
//             const userData = await getUserData();
//             if (!userData) {
//                 Toast.error('Error fetching user:');
//                 navigate('/');
//                 return;
//             }
//             setUser(userData);
//             if (userData?.roles?.includes('editor') || userData?.roles?.includes('administrator')) {
//                 setShowAdmin(true);
//                 setIsLoading(false);
//             } else {
//                 setIsLoading(false);
//                 navigate('/');
//             }
//         } catch (error) {
//             Toast.error('Error fetching user:', error);
//             navigate('/');
//         } finally {
//             setIsLoading(false);
//         }
//     };


//     const handleSubmit = (e) => {
//         e.preventDefault();
//         setError('');
//         setIsVerifying(true);

//         setTimeout(() => {
//             if (code.trim() === correctCode) {
//                 setIsVerified(true);
//             } else {
//                 setError('Incorrect code. Please try again.');
//             }
//             setIsVerifying(false);
//         }, 1500); // Simulate network delay
//     };

//     if (isVerified) {
//         return <RegistrantsTable />;
//     }

//     return (
//         <div className="flex flex-col items-center justify-center min-h-screen bg-gray-700 p-6">
//             <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md">
//                 <h2 className="text-xl font-semibold text-gray-800 mb-0">
//                     Registration List
//                 </h2>
//                 <p className='text-md font-semibold text-gray-800 mb-4'>
//                     (The full admin page is closed – only the Registration List will be available until after THP)
//                 </p>
//                 <p className="text-sm text-gray-600 mb-4">
//                     This admin interface requires an access code. Please enter the access code to proceed.
//                 </p>

//                 <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
//                     <input
//                         type="password"
//                         placeholder="Enter admin access code"
//                         className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-amber-500"
//                         value={code}
//                         onChange={(e) => {
//                             setCode(e.target.value);
//                             setError('');
//                         }}
//                         disabled={isVerifying}
//                     />

//                     {error && <p className="text-red-500 text-sm">{error}</p>}

//                     <button
//                         type="submit"
//                         disabled={isVerifying}
//                         className={`flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-700 text-white font-medium py-2 px-4 rounded-lg transition ${isVerifying ? 'opacity-70 cursor-not-allowed' : ''
//                             }`}
//                     >
//                         {isVerifying ? (
//                             <>
//                                 <span className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></span>
//                                 Verifying...
//                             </>
//                         ) : (
//                             'Verify'
//                         )}
//                     </button>
//                 </form>
//             </div>
//         </div>
//     );

    

// };



const RegistrantsTable = () => {
    const [registrants, setRegistrants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadedCount, setLoadedCount] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'first_name', direction: 'asc' });

    useEffect(() => {
        const fetchRegistrants = async () => {
            const endpoint = 'https://tsoministries.com/wp-json/wp/v2/thp';
            let page = 1;
            let allRegistrants = [];

            try {
                while (true) {
                    const res = await fetch(`${endpoint}?per_page=100&page=${page}&_fields=email_address,first_name,phone_number,surname,volunteer,vip`);
                    if (!res.ok) {
                        if (res.status === 400 && page > 1) break;
                        throw new Error(`Failed at page ${page}`);
                    }
                    const data = await res.json();
                    if (!Array.isArray(data) || data.length === 0) break;

                    allRegistrants = [...allRegistrants, ...data];
                    setLoadedCount(allRegistrants.length); // track how many fetched
                    if (data.length < 100) break;
                    page++;
                }

                // Reindex once
                const indexed = allRegistrants.map((r, i) => ({ ...r, id: i + 1 }));
                setRegistrants(indexed);
            } catch (err) {
                console.error('Error fetching registrants:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchRegistrants();
    }, []);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value.toLowerCase());
    };

    const filteredRegistrants = registrants.filter((r) => {
        const fullText = `${r.email_address} ${r.first_name} ${r.surname} ${r.phone_number} ${r.volunteer}`.toLowerCase();
        return fullText.includes(searchTerm);
    });

    // const sortedRegistrants = [...filteredRegistrants].sort((a, b) => {
    //     const { key, direction } = sortConfig;
    //     const aValue = a[key]?.toString().toLowerCase() || '';
    //     const bValue = b[key]?.toString().toLowerCase() || '';
    //     if (aValue < bValue) return direction === 'asc' ? -1 : 1;
    //     if (aValue > bValue) return direction === 'asc' ? 1 : -1;
    //     return 0;
    // });

    const sortedRegistrants = useMemo(() => {
        const filtered = registrants.filter((r) => {
            const q = searchTerm.toLowerCase();
            return (
                r.email_address?.toLowerCase().includes(q) ||
                r.first_name?.toLowerCase().includes(q) ||
                r.surname?.toLowerCase().includes(q) ||
                r.phone_number?.toLowerCase().includes(q) ||
                r.volunteer?.toLowerCase().includes(q)
            );
        });

        const sorted = [...filtered].sort((a, b) => {
            const aVal = a[sortConfig.key]?.toString().toLowerCase() || '';
            const bVal = b[sortConfig.key]?.toString().toLowerCase() || '';

            if (sortConfig.key === 'id') {
                // Compare numerically
                return sortConfig.direction === 'asc' ? a.id - b.id : b.id - a.id;
            }

            if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
            if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
        });

        return sorted;
    }, [registrants, searchTerm, sortConfig]);

    const toggleSort = (key) => {
        setSortConfig((prev) => {
            const isSameKey = prev.key === key;
            const newDirection = isSameKey && prev.direction === 'asc' ? 'desc' : 'asc';
            return { key, direction: newDirection };
        });
    };

    return (
        <>
            {loading ? (
                <div className="flex flex-col items-center justify-center min-h-screen text-gray-700">
                    <svg className="animate-spin h-10 w-10 text-amber-400 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                    </svg>
                    <p className="text-lg font-semibold text-white">Loading registrants...</p>
                    <p className="text-sm text-gray-300 mt-1">Loaded: {loadedCount}</p>
                </div>
            ) : (
                <div className="p-6 pt-[10vh] overflow-x-auto">
                    <h2 className="text-2xl font-bold mb-4 text-white">THP Registrants List</h2>

                    {/* <div className='w-full flex items-justify'>
                        <input
                            type="text"
                            placeholder="Search by any field..."
                            onChange={handleSearch}
                            className="w-full max-w-md mb-6 p-3 bg-gray-800 rounded-2xl border border-gray-300 shadow-sm focus:outline-none focus:ring-2 focus:ring-pink-300"
                        />

                        <div>
                            <p>{sortConfig.key}</p>
                            <ListFilter />
                            <div>
                                <ArrowUpAZIcon/>
                            </div>
                        </div>
                    </div> */}

                    <FilterBar
                        handleSearch={handleSearch}
                        sortConfig={sortConfig}
                        toggleSort={toggleSort}
                    />

                    {/* Table */}
                    <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
                        <table className="min-w-full text-sm text-left bg-white">
                            <thead className="bg-pink-100 text-gray-700 uppercase text-xs tracking-wider">
                                <tr>
                                    {['ID', 'VIP', 'Surname', 'First Name', 'Email Address', 'Phone Number', 'Volunteer'].map((heading, idx) => (
                                        <th
                                            key={idx}
                                            onClick={() => toggleSort(heading.toLowerCase().replace(' ', '_'))}
                                            className="px-4 py-3 cursor-pointer select-none hover:text-pink-700"
                                        >
                                            {heading}
                                            {sortConfig.key === heading.toLowerCase().replace(' ', '_') && (
                                                <span>{sortConfig.direction === 'asc' ? ' ▲' : ' ▼'}</span>
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {sortedRegistrants.map((r, index) => (
                                    <tr
                                        key={r.id || index}
                                        className={index % 2 === 0 ? 'bg-white hover:bg-red-50 transition' : 'bg-gray-50 hover:bg-pink-50 transition'}
                                    >
                                        <td className="px-4 py-3 font-semibold text-gray-800">{r.id}</td>
                                        <td className={`px-4 py-3 ${r.vip === "true" ? "text-white font-extrabold bg-green-500" : "text-white bg-gray-600"}`}>{r.vip}</td>
                                        <td className="px-4 py-3">{r.surname}</td>
                                        <td className="px-4 py-3">{r.first_name}</td>
                                        <td className="px-4 py-3">{r.email_address}</td>
                                        <td className="px-4 py-3">{r.phone_number}</td>
                                        <td className="px-4 py-3">{r.volunteer}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {sortedRegistrants.length === 0 && (
                        <p className="mt-6 text-center text-gray-500">No results match your search.</p>
                    )}
                </div>
            )}
        </>
    );
};

export default Admin;